import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        direct_dean_list_type: null,
        user_name: {
            user_name: null
        },
        web_con_direct_dean_lists: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        web_con_dean_listMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        setWeb_Con_Direct_Dean_ListsRequest({commit}, payload) {
            if (payload) {

                commit("SET_USERNAME_LIST_TYPE", payload)
            }
        },

        getWeb_Con_Direct_Dean_ListsRequest({dispatch, commit, state}, payload) {

            if (payload) {

                commit("SET_USERNAME_LIST_TYPE", payload)
            } else {
                //playload for search
                payload = {user_name: state.user_name.user_name, direct_dean_list_type: state.direct_dean_list_type}
            }

            // We check if app runs with backend mode

            //console.log(payload); payload is parameter

            if (!config.isBackend) {
                dispatch("receiveWeb_Con_Direct_Dean_Lists", null);
            } else {
                dispatch("receivingWeb_Con_Direct_Dean_Lists"); //


                axios.get('/web_con_direct_dean_lists', {params: payload}).then(res => {
                    dispatch("receiveWeb_Con_Direct_Dean_Lists", res.data);
                })
                    .catch((e) => {
                        console.log(e);
                        dispatch("receiveWeb_Con_Direct_Dean_Lists", null);
                    })
            }
        },
        loadWeb_Con_Direct_Dean_ListRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWeb_Con_Direct_Dean_List", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWeb_Con_Direct_Dean_List");

                axios.get('/web_con_direct_dean_lists/' + id).then(res => {
                    dispatch("receiveWeb_Con_Direct_Dean_List", res.data);
                })
            }
        },
        updateWeb_Con_Direct_Dean_ListRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWeb_Con_Direct_Dean_List");
            axios.put('/web_con_direct_dean_lists/' + payload.direct_dean_list_id, payload).then(res => {
                dispatch("updateWeb_Con_Direct_Dean_List", res.data);
            })
        },
        createWeb_Con_Direct_Dean_ListRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWeb_Con_Direct_Dean_List");
            axios.post('/web_con_direct_dean_lists', payload).then(res => {
                dispatch("receiveWeb_Con_Direct_Dean_List", res.data);
            })
        },
        deleteWeb_Con_Direct_Dean_ListRequest({dispatch}, payload) {

            dispatch("afterDeleteWeb_Con_Direct_Dean_List", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWeb_Con_Direct_Dean_List", payload);

            axios.post('/delete_web_con_direct_dean_lists', payload).then(res => {
                dispatch("deleteWeb_Con_Direct_Dean_List", {
                    direct_dean_list_id: payload.direct_dean_list_id,
                    res: res
                });
            })


        },
        receiveWeb_Con_Direct_Dean_Lists({commit}, payload) {
            commit("RECEIVED_CON_DIRECT_DEAN_LISTS", payload)
        },
        receivingWeb_Con_Direct_Dean_Lists({commit}) {
            commit("RECEIVING_CON_DIRECT_DEAN_LISTS") //call matutions --> state.isReceiving = true;
        },
        receiveWeb_Con_Direct_Dean_List({commit}, payload) {
            commit("RECEIVED_CON_DIRECT_DEAN_LIST", payload)
        },
        receivingWeb_Con_Direct_Dean_List({commit}) {
            commit("RECEIVING_CON_DIRECT_DEAN_LISTS") //call matutions --> state.isReceiving = true;
        },
        updateWeb_Con_Direct_Dean_List({commit}, payload) {
            commit("UPDATED_CON_DIRECT_DEAN_LIST", payload)
        },
        updatingWeb_Con_Direct_Dean_List({commit}) {
            commit("UPDATING_CON_DIRECT_DEAN_LIST") //  call matutions --> state.isUpdating = true;
        },
        deleteWeb_Con_Direct_Dean_List({commit}, payload) {
            commit("DELETED_CON_DIRECT_DEAN_LIST", payload)
        },
        deletingWeb_Con_Direct_Dean_List({commit}, payload) {
            commit("DELETING_CON_DIRECT_DEAN_LIST", payload)
        },
        afterDeleteWeb_Con_Direct_Dean_List({commit}, payload) {
            commit("AFFTER_DELETED_CON_DIRECT_DEAN_LIST", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //


        RECEIVED_CON_DIRECT_DEAN_LISTS(state, payload) {
            state.web_con_direct_dean_lists = payload;
            state.isReceiving = false;

        },
        RECEIVING_CON_DIRECT_DEAN_LISTS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },
        RECEIVED_CON_DIRECT_DEAN_LIST(state, payload) {


            if (payload.direct_dean_list_id == undefined) {
                let error = !payload.e.errorInfo == true ? payload.message : payload.e.errorInfo.toString()
                let web_con_dean_listMessage = 'พบข้อผิดพลาด :' + error
                state = Object.assign(state, {
                    isReceiving: false,
                    web_con_dean_listMessage: (state.web_con_dean_listMessage == web_con_dean_listMessage ? web_con_dean_listMessage + ' ' : web_con_dean_listMessage),

                });
            } else {
                let web_con_dean_listMessage = 'บันทึกสำเร็จ! รายการ ' + payload.direct_dean_list_id + ' ถูกบันทึกแล้ว';

                state = Object.assign(state, {
                    web_con_direct_dean_lists: [...state.web_con_direct_dean_lists, payload],
                    isReceiving: false,
                    errorMessage: false,
                    web_con_dean_listMessage: (state.web_con_dean_listMessage == web_con_dean_listMessage ? web_con_dean_listMessage + ' ' : web_con_dean_listMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_CON_DIRECT_DEAN_LIST(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_CON_DIRECT_DEAN_LIST(state, payload) {


            let index = state.web_con_direct_dean_lists.findIndex(p => p.direct_dean_list_id === payload.direct_dean_list_id);
            let web_con_dean_listMessage = 'บันทึกสำเร็จ! รายการ ' + payload.direct_dean_list_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                web_con_direct_dean_lists: state.web_con_direct_dean_lists.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                web_con_dean_listMessage: (state.web_con_dean_listMessage == web_con_dean_listMessage ? web_con_dean_listMessage + ' ' : web_con_dean_listMessage),
            })
        },
        UPDATING_CON_DIRECT_DEAN_LIST(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },
        DELETED_CON_DIRECT_DEAN_LIST(state, payload) {


            if (payload.direct_dean_list_id == undefined || payload.res.data.message == 'Relation') {
                let web_con_dean_listMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.direct_dean_list_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    web_con_dean_listMessage: (state.web_con_dean_listMessage == web_con_dean_listMessage ? web_con_dean_listMessage + ' ' : web_con_dean_listMessage),

                });
            } else {
                let indexToDelete = state.web_con_direct_dean_lists.findIndex(p => p.direct_dean_list_id === payload.direct_dean_list_id);
                let web_con_direct_dean_lists = [...state.web_con_direct_dean_lists];
                web_con_direct_dean_lists.splice(indexToDelete, 1);
                let web_con_dean_listMessage = 'บันทึกสำเร็จ! รายการ ' + payload.direct_dean_list_id + ' ถูกลบแล้ว';

                state = Object.assign(state, {
                    web_con_direct_dean_lists: [...web_con_direct_dean_lists],
                    isDeleting: false,
                    idToDelete: null,
                    web_con_dean_listMessage: (state.web_con_dean_listMessage == web_con_dean_listMessage ? web_con_dean_listMessage + ' ' : web_con_dean_listMessage),
                    errorMessage: false
                });
            }

        },
        DELETING_CON_DIRECT_DEAN_LIST(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.direct_dean_list_id;
        },
        AFFTER_DELETED_CON_DIRECT_DEAN_LIST(state) {
            state.errorMessage = false;

        },
        SET_USERNAME_LIST_TYPE(state, payload) {
            state.user_name.user_name = payload.user_name;
            state.direct_dean_list_type = payload.direct_dean_list_type;
            state.errorMessage = false;
            state.web_con_dean_listMessage = '';

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
